define("active-model-adapter/index", ["exports", "active-model-adapter/active-model-adapter", "active-model-adapter/active-model-serializer"], function (_exports, _activeModelAdapter, _activeModelSerializer) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "ActiveModelAdapter", {
    enumerable: true,
    get: function () {
      return _activeModelAdapter.default;
    }
  });
  Object.defineProperty(_exports, "ActiveModelSerializer", {
    enumerable: true,
    get: function () {
      return _activeModelSerializer.default;
    }
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"active-model-adapter/active-model-adapter",0,"active-model-adapter/active-model-serializer"eaimeta@70e063a35619d71f
  var _default = _exports.default = _activeModelAdapter.default;
});